import React, { useMemo, useEffect } from 'react';
import block from 'bem-cn';
import { useSelector, useDispatch } from 'react-redux';
import SVGInline from 'react-svg-inline';
import { GridLoader } from 'react-spinners';

import { getIconById } from 'components/Header/img/icons';
import { actions } from '../';

import './TopWins.scss';

const TopWins = () => {
  const dispatch = useDispatch();
  const b = block('top-wins');
  const locale = useSelector(state => state.locale.locale);
  const { topWins, isProcess } = useSelector(state => state.history);

  useEffect(() => {
    dispatch(actions.getTopWins());
  }, [dispatch])

  const topWinsList = useMemo(() => (
    topWins.map((t, i) => (
      <div key={i} className={b('item')}>
        <div className={b('column')}>
          <SVGInline svg={getIconById(t.icon_id)} className={b('icon').toString()} />
          {t.nick || t.user_id}
        </div>
        <div className={b('column', { type: 'names' })}>
          <div className={b('row')}>{locale.bet}</div>
          <div className={b('row')}>{locale.win}</div>
          <div className={b('row')}>{locale.roundID}</div>
        </div>
        <div className={b('column', { type: 'values' })}>
          <div className={b('row')}>{`${t.bet_amount} ${t.currency}`}</div>
          <div className={b('row')}>{`${(+t.win_amount).toFixed(2)} ${t.currency}`}</div>
          <div className={b('row')}>{t.game_id}</div>
        </div>
      </div>
    ))
  ), [b, locale, topWins])

  return <section className={b()}>
    <GridLoader loading={isProcess} color="var(--accent-color)" size={50} css={{ position: 'fixed', top: '50%', transform: 'translateY(-50%)', zIndex: 100 }}/>
    <div className={b('items')}>
      {topWinsList}
    </div>
  </section>
}

export default TopWins;